import { faLayerGroup, faCalculator } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../../Context/User";
import { ACESSOS } from "../../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../../Validations/UsuarioTela";
import { Dispatch, SetStateAction } from "react";
import { IComponentModal } from "../../../Modais/IModalComponent";
import RepasseDadosBI from "../RepasseDadosBI";


interface ISubNavGestaoCadastrosRepasse {
    SetShow: Dispatch<SetStateAction<boolean>>;
    SetModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
}

export function SubNavGestaoCadastrosRepasse({ SetModal, SetShow }: ISubNavGestaoCadastrosRepasse) {
    const { UserInfor } = useUserInfor();

    return (
        <>
            {mostrarNavDeTela(
                ACESSOS.REPASSE.TELAS.ETAPAS_GRUPO.ID_TELA,
                UserInfor.TELAS
            ) && (
                    <li className="menu-item">
                        <NavLink
                            to={ACESSOS.REPASSE.TELAS.ETAPAS_GRUPO.DS_PATH}
                            exact
                            activeClassName="active"
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faLayerGroup} />
                            </span>
                            <span className="menu-text">Etapas por Grupo</span>
                        </NavLink>
                    </li>
                )}
            {mostrarNavDeTela(
                ACESSOS.REPASSE.TELAS.REPASSE_BI.ID_TELA,
                UserInfor.TELAS
            ) && (
                    <li className="menu-item">
                        <a
                            href="#/"
                            className="menu-link active"
                            onClick={() => {
                                SetShow(true);
                                SetModal({
                                    Children: (
                                        <RepasseDadosBI SetShow={SetShow} />
                                    ),
                                    headerComponent:
                                        "Repasse Dados BI",
                                    size: "lg",
                                });
                            }}
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faCalculator} />
                            </span>
                            <span className="menu-text">Repasse Dados BI</span>
                        </a>
                    </li>
                )}
        </>
    );
}
